
export const environment = {
  production: true,
  lexiVersion: 'PROD',
  baseServiceUrl: window.location.origin,
  useInternationalisation: true,
  showCreationPiece: true
};
